import React, {FC, useEffect, useState} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import {PageTitle} from '../../../_metronic/layout/core'
import {MixedWidget21} from '../../../_metronic/partials/widgets'
import Loader from '../component/Loader'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewTourPackages: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
      if (categoryId != '5') {
        navigate('../dashboard/');
      }
    }, [categoryId])
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
      var vendor = JSON.parse(vendorData);
      vendorId = vendor.vendorId;
      
  } else {
      console.log("No vendor data found");
  }
  const [offset,setoffset]=useState(0)
  const [limit,setlimit]=useState(9);
  const [page,setpage]=useState(1)
  const [totalPage,setTotalPage]=useState(1)
  const [from,setfrom]=useState(1)
  const [to,setTo]=useState(1)
  const [tourPackageList, setTourPackageList] = useState([]);
  const [displayTourPackageList, setDisplayTourPackageList] = useState([]);
  const [pageNumbersList,setPageNumberList]=useState([1])
  const [isLoading, setIsLoading] = useState(false);
  // page number generater
  function generatePageNumbers(currentPage:any, totalPages:any, maxPagesToShow:any) {
      const halfMaxPages = Math.floor(maxPagesToShow / 2);
      let startPage = Math.max(1, currentPage - halfMaxPages);
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
      if (endPage - startPage + 1 < maxPagesToShow) {
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      // Generate the list of page numbers
      const pageNumbers = [];
      for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
      }

      return pageNumbers;
  }
  // on page change function
  const onpagecahnge=(pageId:any)=>{
    if(pageId!=page && pageId!=0 && pageId<=totalPage)
    {
      var tmp=(pageId-1)*limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp+1)
      // setto
      var mod=tourPackageList.length%limit
      var tolimi:any=limit
      if(mod>0)
      {
        if(mod<=limit)
        {
          tolimi=pageId*limit
          
        }
        else
        {
          tolimi=pageId*limit+limit
        }
      }
      else
      {
        tolimi=pageId*limit
      }
      setTo(tolimi)
      var tmpdata:any=tourPackageList.slice(tmp,tolimi)
      setDisplayTourPackageList(tmpdata)
    }

  }
  //   tour package list api call
  const tourpackageListAPIcall=async()=>{
      setIsLoading(true)
      var param={
          'vendorId':vendorId
      }
      var res=await fetchData("public/tourpackageList",param)
      
      if(res.status=="200")
      {
        setIsLoading(false)
        var data = res.data;
        setTourPackageList(data);
        var tmp:any=res.data.slice(offset, offset+limit);
        setDisplayTourPackageList(tmp)
        var totpag=(Math.ceil(res.data.length/limit))
        setTotalPage(totpag)
        if(totpag==1)
        {
          var mod=res.data.length%limit
          if(mod>0)
          {
            setTo(mod)
          }
          else
          {
            setTo(tmp.length)
          }
        }
        else
        {
          var mod=res.data.length%limit
          if(mod>0)
          {
            setTo(page*limit+mod)
          }
          else
          {
            setTo(page*limit)
          }
        }

        var genpag=generatePageNumbers(page,totpag,6)
        setPageNumberList(genpag)
      }
      else
      {
          toasterrormsg(res.message)
      }
  }
    //   delete hotel api call
    const confirmdelete=(tourpackageId:any)=>{
      Swal.fire({
        title: t('Are you sure?'),
        text: t('You Want To Delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('Yes'),
        cancelButtonText: t('No'),
      }).then(async (result) => {
        if (result.isConfirmed) {
        
          var param={
            'tourpackageId':tourpackageId
          }
          var res=await fetchData("public/deleteTourPackage",param)
          
          if(res.status=="200")
          {
            tourpackageListAPIcall();
          }
          else
          {
              toasterrormsg(res.message)
          }
        } 
      });
    }

  useEffect(()=>{
    tourpackageListAPIcall();
  },[])
  return (
    <>
    {isLoading && (<Loader />)} 
      <PageTitle breadcrumbs={[]}>{t('View Tour Packages')}</PageTitle>
      <div className="d-flex justify-content-end my-2">
        <Link
          className='btn bg-white btn-active-light-primary cursor-pointer'
          id='kt_toolbar_primary_button'
          style={{color: 'rgb(24, 28, 50)'}}
          to="../addtourpackagebasicinfo/"
        >
          + {t('Add Tour Package')}
        </Link>
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
      { 
        displayTourPackageList.map((tourPackage:any,index:any)=>{
          var percentage = 0;
          if (tourPackage['completedSteps']['basicInfo']) {
              percentage = 10;
          }
          if (tourPackage['completedSteps']['location']) {
              percentage = 20;
          }
          if (tourPackage['completedSteps']['toursDetail']) {
              percentage = 60;
          }
          if (tourPackage['completedSteps']['photos']) {
              percentage = 70;
          }
          if (tourPackage['completedSteps']['policies']) {
              percentage = 90;
          }
          if (tourPackage['completedSteps']['financeAndLegal']) {
              percentage = 100;
          }
          var description = getTranslatedValue(lang, tourPackage, '_userGuide');
          var tourPackageName = getTranslatedValue(lang, tourPackage, '_agencyName');
          return(
            <div className='col-xl-4' key={index}>
              <MixedWidget21
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                tourpackageId={tourPackage['tourpackageId']} 
                businessInfostatus={tourPackage['businessInfostatus']} 
                businessRejectReason={tourPackage['businessRejectReason']} 
                deleteTourPackage={confirmdelete}
                tourPackageName={tourPackageName}
                image={(tourPackage['images'].length != 0) ? tourPackage['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                description={description}
                progress={`${percentage}%`}
              />
            </div>
          )
        })
      }
      </div>
      {/* end::Row */}
      {
        tourPackageList.length == 0 && (
          <div className="d-flex flex-column flex-center text-center p-10">        
              <div className="card card-flush w-100 py-5">
                  <div className="card-body py-15 py-lg-20">
                    <div className="fw-semibold fs-6 text-gray-500 mb-7">
                        {t('There are no records to display')}
                    </div>   
                  </div>
              </div>
          </div>
        )
      }
      {
        tourPackageList.length != 0 ? (
          <div className='d-flex flex-stack flex-wrap pt-10'>
              <div className='fs-6 fw-bold text-gray-700'>{t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(tourPackageList.length))}</div>

              <ul className='pagination'>
                
                <li className={`page-item previous ${page>1?"":"disabled"}`}>
                  <span className={`page-link ${page>1?"cursor-pointer":"disabled"}`} onClick={()=>onpagecahnge(page-1)}>
                    <i className='previous'></i>
                  </span>
                </li>
                {pageNumbersList.map((item:any,index:any)=>{
                  return(
                    <li className={`page-item cursor-pointer ${page==item?"active":""}`} key={index}>
                      <span className='page-link' onClick={()=>onpagecahnge(item)}>
                        {item}
                      </span>
                    </li>
                  )
                })}
                <li className={`page-item next ${page+1<=totalPage?"":"disabled"}`}>
                  <span className={`page-link ${page+1<=totalPage?"cursor-pointer":"disabled"}`} onClick={()=>page+1<=totalPage?onpagecahnge(page+1):""}>
                    <i className='next'></i>
                  </span>
                </li> 
              </ul>
          </div>
        ):("")
      }

    </>
  )
}

export {ViewTourPackages}
